<template>
  <div>
    <!-- <v-layout justify-center>
      <v-flex>
      
        <v-slide-y-transition mode="out-in"> -->
          <v-container fluid class="pa-3">

            <v-btn
              fixed
              bottom
              dark
              fab
              right
              color="primary"
              transition="slide-y-reverse-transition"
              @click.stop="drawer = !drawer"
            >
              <v-icon>summarize</v-icon>
            </v-btn>

            <v-layout row wrap>
              <v-flex>
                <v-card>

                  <v-toolbar dense prominent>
                    <v-toolbar-title>
                      JOB APPLICATION {{ current_req.length==0?'':' - ' + current_req[0].name + ' (' + current_req[0].status + ')' }}
                    </v-toolbar-title>
                    <v-spacer></v-spacer>

                    <v-toolbar-items>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-btn small fab :href="'req_application_forms?uuid=d5b82c80-afc2-489a-81a2-d949ad139891&_id=' + selected._id + '&email_invi=' + selected.email_invi + '&reqid=' + selected.req_id" v-on="on">
                            <v-icon>arrow_back</v-icon> 
                          </v-btn>
                        </template>
                        <span>Back to Form Listing</span>
                      </v-tooltip>
                    </v-toolbar-items>
                  
                  </v-toolbar>

                  <v-card-text>
                    <!-- <v-container fluid ma-0 pa-0> -->
                      <v-layout row wrap>

                        <v-flex xs12 md4>
                          <v-card-text>
                            <v-form ref="MainForm">
                              <v-container fluid ma-0 pa-0>
                                <v-layout row wrap>
                                  <v-flex xs12>
                                  <v-text-field
                                    readonly
                                    :value="selected.req_id"
                                    label="#ID (Requisition)"
                                  ></v-text-field>
                                </v-flex>

                                  <v-flex xs12>
                                    <v-text-field
                                      readonly
                                      :value="selected._id"
                                      label="#ID"
                                    ></v-text-field>
                                  </v-flex>
                                
                                  <v-flex xs12>
                                    <v-text-field
                                      readonly
                                      :value="selected.name"
                                      label="Name"
                                    ></v-text-field>
                                  </v-flex>
                                
                                  <v-flex xs12>
                                    <v-text-field
                                      readonly
                                      :value="selected.username"
                                      label="Username"
                                    ></v-text-field>
                                  </v-flex>

                                  <v-flex xs12>
                                    <v-text-field
                                      readonly
                                      :value="selected.contact_no"
                                      label="Contact No."
                                    ></v-text-field>
                                  </v-flex>
                                
                                  <v-flex xs12>
                                    <v-text-field
                                      readonly
                                      :value="selected.email"
                                      label="Email"
                                    ></v-text-field>
                                  </v-flex>

                                  <v-flex xs12 v-if="is_mgr">
                                    <v-textarea
                                      v-model="selected.remark"
                                      label="Remark"
                                      hint="Max 1000 characters."
                                    ></v-textarea>
                                  </v-flex>

                                </v-layout>
                              </v-container>
                            </v-form>
                          </v-card-text>

                          <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="green" flat @click="save_onClick()" v-if="is_mgr" :disabled="!btnSave">
                              Save
                            </v-btn>
                          </v-card-actions>

                        </v-flex>

                        <v-flex xs12 md8>

                          <v-card color="accent">
                            <v-card-title class="headline">
                              {{ iframe.title }}
                              <v-spacer></v-spacer>
                              <v-btn
                                depressed round
                                color="primary"
                                @click="btn_onClick(current_form,true)"
                                v-if="form_toggle && is_mgr"
                              >{{ is_graph==1?'View Form':'View Graph' }}</v-btn>
                              <v-btn
                                depressed round
                                color="primary"
                                @click="btn_print()"
                              >Print</v-btn>
                            </v-card-title>

                            <v-card-text class="white">
                              <v-container class="pa-0">
                                <v-layout row wrap>
                                  <v-flex class="grey--text text--darken-2" xs12 md6>
                                    Created: <b>{{ epoch2localedatetime(iframe.created) }} - {{ iframe.created_by }}</b>
                                  </v-flex>
                                  <v-flex class="grey--text text--darken-2" xs12 md6>
                                    Modified: <b>{{ epoch2localedatetime(iframe.modified) }} - {{ iframe.modified_by }}</b>
                                  </v-flex>
                                </v-layout>
                              </v-container>
                            </v-card-text>

                            <div class="pt-2" style="background-color: white;" v-if="show_iframe">
                              <iframe
                                id="id_Iframe"
                                :src="iframe.url"
                                frameborder="0"
                                width="100%"
                                :height="iframe.height"
                              ></iframe>
                            </div>
                          </v-card>

                        </v-flex>
                      </v-layout>
                    <!-- </v-container> -->
                  
                  </v-card-text>
                </v-card>

              </v-flex>
            </v-layout>
          </v-container>
        <!-- </v-slide-y-transition>

      </v-flex>
    </v-layout> -->

    <v-navigation-drawer
      v-model="drawer"
      right
      temporary
      fixed
    >
      <v-container>
        <v-layout fow wrap>
          <v-flex
            class="pa-3"
            v-for="(form, i) in selected.forms"
            :key="i"
          >
            <v-card @click="btn_onClick(form, false)" style="cursor:pointer;" :color="form.info.status?'success':'info'">
              <v-card-text style="text-align: center;">
                <div>
                  <span><b>{{ form.info.form_name }}</b></span><br>
                  <span style="font-size:medium"><b>{{ form.info.form_description }}</b></span><br><br>
                  <span>{{ form.info.status?"Done":"New" }}</span>
                </div>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-navigation-drawer>
  </div>
</template>
  
<script>
import auth from "../../functions/auth";
import common from "../../functions/general";
import comm from "../../functions/communication.api";

export default {
  name: "req_application_fill_forms",
  data() {
    return {
      username: "",
      selected: {
        req_id: "",
				_id: "",
        name: "",
        username: "",
        email: "",
        contact_no: "",
        email_invi: null,
        email_info: {},
        email_log: [],
        forms: [],
        remark: "",
        g_status_id: "",
        created:0,
        created_by:"",
        modified:0,
        modified_by:"",
      },
      iframe: {
        url: "",
        height: "700",
        form_type: "",
        form_id: "",
        title: "",
        created: 0,
        created_by: "",
        modified: 0,
        modified_by: ""
      },
      user_roles: [],
      auth_role: false,
      form_list: [],
      drawer: null,
      is_graph: 0,
      current_form: {},
      form_toggle: false,
      btnSave: false,
      is_mgr: false,
      current_req: []
    }
  },
  computed: {
    show_iframe () {
      if (this.selected.req_id==null || this.selected.req_id=="") {
        return false;
      }
      return true;
    }
  },
  watch: {
    "selected.remark": {
      handler: function() {
        this.btnSave = true;
      },
      // deep: true
    },
  },
  async mounted() {
    common.App.loader.show(this);
    common.App.set_page_title("mySuite: Req Forms");

    this.username = auth.getUsername();

    let temp = common.App.getQueryString("email_invi");
    this.selected.email_invi = temp!=null?parseInt(temp):null;

    this.selected.req_id = common.App.getQueryString("reqid");
    this.selected._id = common.App.getQueryString("_id");

    this.iframe.form_type = common.App.getQueryString("form_type");
    this.iframe.form_id = common.App.getQueryString("form_id");
    this.is_graph = parseInt(common.App.getQueryString("graph"));

    let res = await common.wBackEndComm.GetData("users/api_get_user_roles/");
    res = res.data;
    if (res.Status == 1) {
      this.user_roles = res.Body;
    } else {
      common.wMsgBox.Error(res.Description);
    }

    res = await common.wBackEndComm.GetData("mycareer/requisition_listing/?_id=" + this.selected.req_id);
    res = res.data;
    if (res.Status == 1) {
      this.current_req = res.Body[0].records;
    } else {
      common.wMsgBox.Error(res.Description);
    }

    this.auth_role = common.App.check_role(this.user_roles, 7);

    await this.refreshData();

    // // check is_mgr
    // if (this.auth_role && (this.selected.username != this.username)) {
    //   this.is_mgr = true;
    // }

    var self = this;

    async function handleMessage(e) {
      
      if (e.data.event == "form_data_saved") {
        common.App.loader.show(self);

        let obj = {
          "_id": self.selected._id,
          "form_id": self.iframe.form_id,
          "form_data_id": e.data.form_datas_id
        };

        let res = await common.wBackEndComm.PostData("mycareer/pub_iform_update/", obj);
        res = res.data;
        if (res.Status == 1) {
          window.location.reload();
        } else {
          common.wMsgBox.Error(res.Description);
        }

        common.App.loader.hide(self);
      }

      if (e.data.event == "form_data_saved_btrt") {
        common.App.loader.show(self);

        let obj = {
          "_id": self.selected._id,
          "self_key": e.data.key.self_key,
          "obs_key": e.data.key.obs_key
        };

        let res = await common.wBackEndComm.PostData("mycareer/pub_btrt_update/", obj);
        res = res.data;
        if (res.Status == 1) {
          window.location.reload();
        } else {
          common.wMsgBox.Error(res.Description);
        }

        common.App.loader.hide(self);

        self.iframe.height = e.data.window.height;
      }

      if (e.data.event == "form_loaded") {
        self.iframe.height = e.data.window.height;
      }
    }

    window.addEventListener("message", handleMessage, false);

    this.btnSave = false;

  },
  created(){

  },
  methods: {
    epoch2localedatetime: common.App.epoch2LocaleDatetime,
    get_URL(type) {
      let base = "";

      switch (type) {
        case "get":
          base = "mycareer/applicants_crud/?uuid=4fa09d2a-b89e-463e-9416-6c99118712c6&email_invi=";
          break;

        // case "post":
        //   base = "req_applicants_crud?pageid=227&email_invi=";
        //   break;

        // case "sendEmail":
        //   base = "req_email_invi?pageid=228&email_invi=";
        //   break;

        case "fillForm":
          base = "req_application_fill_forms?uuid=5efc4c51-96ea-427a-85e2-110fd801d9dd&email_invi=";
          break;
      }

      let temp = [
          base,
          this.selected.email_invi,
          "&reqid=",
          this.selected.req_id,
          "&_id=",
          this.selected._id
        ];
        temp = temp.join("");
      return temp;
    },
    async refreshData() {
      // console.log("sss",this.get_URL("get"));
      let res = await common.wBackEndComm.GetData(this.get_URL("get"));
      res = res.data;
      if (res.Status == 1) {
        this.selected = res.Body;
        this.selected.email = this.selected.email[0];
      } else {
        common.wMsgBox.Error(res.Description);
      }
      common.App.loader.hide(this);

      // check is_mgr
      if (this.auth_role && (this.selected.username != this.username)) {
        this.is_mgr = true;
      }

      this.form_display(this.iframe.form_type);

    },
    form_display(formType) {
      var form_obj = {};

      switch (formType) {
        
        case "iform":
          form_obj = this.selected.forms.find(rec => rec.info.form_id == this.iframe.form_id);
          this.current_form = form_obj;
          this.form_toggle = false;
          this.get_form_title(form_obj);

          var temp_arr = [
            comm.form_ip,
            form_obj.info.form_id,
            "&form_data_id=",
            form_obj.info.form_data_id,
            "&reqid=",
            this.selected.req_id,
            "&name=",
            this.selected.name,
            "&email=",
            this.selected.email,
            "&contact_no=",
            this.selected.contact_no
          ];

          // if (form_obj.info.status==1 && !this.is_mgr) {
          if (form_obj.info.status==1) {
            temp_arr.push("&readOnly=true");
          }

          if (form_obj.info.status==0 && this.is_mgr) {
            temp_arr.push("&readOnly=true");
          }

          this.iframe.url = temp_arr.join("");

          this.get_create_modify_info(form_obj);
          break;

        case "btrt":
          form_obj = this.selected.forms.find(rec => rec.info.form_id == "form/btrt");
          this.form_toggle = true;
          this.current_form = form_obj;
          this.get_form_title(form_obj);

          var temp_arr_form = [
            comm.BTRT_url,
            "btrt_form_r1/?key=",
            form_obj.info.others_info.self_key,
            "&Nname=",
            this.selected.name,
            "&username=",
            this.selected.username,
            "&reqID=",
            this.selected.req_id
          ];
          var temp_url_form = temp_arr_form.join("");

          var temp_arr_graph = [
            comm.BTRT_url,
            "graph_btrt_r1/?key=",
            form_obj.info.others_info.self_key
          ];
          var temp_url_graph = temp_arr_graph.join("");
          
          if (this.is_graph == 1 && this.is_mgr) {
            this.iframe.url = temp_url_graph;
          } else {
            this.iframe.url = temp_url_form;
          }

          if (this.is_mgr) {
            this.iframe.url += "&readOnly=true";
          }
          
          this.get_create_modify_info(form_obj);
          break;
      }
    },
    get_form_title(obj) {
      this.iframe.title = obj.info.form_name + ": " + obj.info.form_description;
    },
    get_create_modify_info(form_obj) {
      this.iframe.created = form_obj.info.created;
      this.iframe.created_by = form_obj.info.created_by;
      this.iframe.modified = form_obj.info.modified;
      this.iframe.modified_by = form_obj.info.modified_by;
    },
    btn_onClick(form, toggle) {
      let url = this.get_URL("fillForm");

      let temp = [
        url,
        "&form_type=",
        form.type,
        "&form_id=",
        form.info.form_id,
        "&graph="        
      ];
      
      if (toggle) {
        this.is_graph = (this.is_graph - 1)*(-1); // toggle btwn 1 and 0
        temp.push(this.is_graph);
      } else {
        temp.push(form.info.status);
      }
      
      window.location.href = temp.join("");
    },
    async save_onClick() {
			common.App.loader.show(this);

			if (this.$refs.MainForm.validate()) {
        // var new_rec = !this.selected._id;

        var postData = {
          "applicant_username": this.selected.username,
          "email_invi": this.selected.email_invi,
          "data": {
            "_id": this.selected._id ? this.selected._id:"",
            "remark": this.selected.remark
          }
        };
        
				var url = "mycareer/applicants_crud/";
				var result = await common.wBackEndComm.PostData(url, postData);
				result = result.data;

				if (result.Status == 1) {
					this.selected.modified = result.Body.modified;
          this.selected.modified_by = result.Body.modified_by;

          this.$nextTick(() => {
            this.btnSave = false;
          });

					common.wMsgBox.Success(result.Description);
				} else {
					common.wMsgBox.Error(result.Description);
				}
			// } else {
			// 	common.wMsgBox.Error(
			// 		"Please fill in all required fields before click on save button."
			// 	);
			}
			common.App.loader.hide(this);
    },
    btn_print() {
      var iframe = document.getElementById('id_Iframe');
      var message = {
        event: "print_document"
      };
      iframe.contentWindow.postMessage(message, this.iframe.url);
    }
  }
};
</script>

<style>
</style>